import TotalUsers from "../widgets/cards/totalUsers";
import { useState } from "react";
import { LoadingPage } from "../widgets/small-widgets";
import { getPermissions, hasPermission } from "../firebase/firestore/permisions";
import HomeMails from "../widgets/home/mails";
import Balance from "../widgets/cards/balance";
import { useTranslation } from "react-i18next";

export default function HomePage() {
    const [userPermissions, setUserPermissions] = useState(null);
    const { t } = useTranslation();

    async function getUserPermissions() {
        const permissions = await getPermissions();
        console.log(permissions);
        setUserPermissions(permissions);
    }

    if (userPermissions === null) {
        getUserPermissions();
        return <LoadingPage/>;
    }

    return <div style={{padding: '1.2rem', minHeight: 'calc(100vh - 140px)'}}>
        <section id="highlight-data" className="home-page-flex">
            {hasPermission('user-read', userPermissions)
                ? <TotalUsers/> : null
            }
            {hasPermission('balance-read', userPermissions)
                ? <Balance/> : null
            }
        </section>

        {hasPermission('mail-read', userPermissions)
            ? <section id="mails-data" style={{margin: 10}}>
                <h2 style={{color: 'var(--h2-color)'}}>{t('homePage.lastMails')}</h2>
                <HomeMails/>
            </section> : null
        }
    </div>;
}